module.exports = __webpack_public_path__ + "static/lunchtype24-light-expanded-webfont-f7509b6d07577d48bbcd71aed4fb551c.woff2";